// GeneratedAppBlocked — what a viewer mounts IN PLACE of an AI-generated app
// the containment gate refused (functions/generatedAppContainment.js; Nika
// 2026-10-01 "Cut access now"). None of the app's own code runs: the builder
// (functions/index.js parseGeneratedAppSource) refused it before evaluation,
// and this page is the whole mount.
//
// The house error state (shared ErrorState, kind 'forbidden') with one action:
// ask the AI to rebuild the app with the allowed features. The request names
// the app and what the gate refused, so the model can fix exactly that.
// State (set by functions/index.js generatedAppBlockedDef): appName,
// blockedReasons (rule: detail strings).
export const GeneratedAppBlocked = {
  extends: 'ErrorState',
  kind: 'forbidden',
  heading: 'workspace.appBlocked.heading',
  hintText: 'workspace.appBlocked.hint',
  action: {
    text: 'workspace.appBlocked.rebuild',
    onClick: (e, el, s) => {
      const reasons = Array.isArray(s.blockedReasons) ? s.blockedReasons : []
      const prompt = el
        .call('polyglot', 'workspace.appBlocked.rebuildPrompt')
        .replace('{name}', s.appName || el.call('polyglot', 'workspace.apps.nameFallback'))
        .replace('{reasons}', reasons.join('; '))
      el.call('homeAiSend', prompt)
    }
  }
}
